import React from "react";
import Profiles from "../../components/Profiles/Profiles";

export default function ProfilePage() {
  return <Profiles />;
}
